import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ClientScreen from '../../screens/Client/ClientScreen';
import { supabase } from '../../supabaseClient';

const ClientsContainer = ({}) => {
  const [data, setData] = useState([]);
  const reloadClient = useSelector((state) => state.app.reloadClient || false);
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});

  useEffect(() => {
    loadData();
  }, [reloadClient, company]);

  const loadData = async () => {
    console.log(
      'ClientsContainer - Carregando clientes para company.id:',
      company.id
    );

    // Primeiro: tentar com os joins
    // IMPORTANTE: Supabase limita a 1000 por padrão, usando range para buscar todos
    let allData = [];
    let error = null;
    let count = 0;
    const pageSize = 1000;
    let page = 0;
    let hasMore = true;

    while (hasMore) {
      const from = page * pageSize;
      const to = from + pageSize - 1;

      let {
        data: pageData,
        error: pageError,
        count: totalCount,
      } = await supabase
        .from('Client')
        .select('*', { count: 'exact' })
        .eq('id_company', company.id)
        .is('deleted_at', null)
        .range(from, to)
        .order('created_at', { ascending: false });

      if (pageError) {
        error = pageError;
        break;
      }

      if (totalCount !== null) {
        count = totalCount;
      }

      if (pageData && pageData.length > 0) {
        allData = [...allData, ...pageData];
      }

      hasMore = pageData && pageData.length === pageSize;
      page++;
    }

    const data = allData;

    console.log('ClientsContainer - Resposta do banco (COM joins):', {
      data,
      error,
      count,
    });
    console.log('ClientsContainer - Count no banco:', count);
    console.log(
      'ClientsContainer - Quantidade retornada (COM joins):',
      data?.length || 0
    );

    if (data && data.length > 0) {
      console.log(
        'ClientsContainer - Primeiros 3 clientes:',
        data.slice(0, 3).map((c) => ({ id: c.id, name: c.name }))
      );
    }

    // Se falhou ou retornou vazio, tentar SEM joins para debug
    if (error || (data && data.length === 0)) {
      console.log('ClientsContainer - Tentando SEM joins...');
      let { data: dataSimple, error: errorSimple } = await supabase
        .from('Client')
        .select('*')
        .eq('id_company', company.id)
        .is('deleted_at', null);

      console.log('ClientsContainer - Resposta SEM joins:', {
        data: dataSimple,
        error: errorSimple,
        quantidade: dataSimple?.length || 0,
      });

      // Se funcionou sem joins, usar esses dados
      if (!errorSimple && dataSimple && dataSimple.length > 0) {
        console.warn(
          'AVISO: Clientes só aparecem SEM joins! Problema nas relações Vehicle/Origin'
        );
        setData(
          dataSimple.map((item) => ({
            ...item,
            created_at: dayjs(item.created_at).format('DD/MM/YYYY'),
          }))
        );
        return;
      }
    }

    if (error) {
      console.error('ClientsContainer - Erro ao carregar clientes:', error);
    }

    if (!error && data) {
      setData(
        data.map((item) => ({
          ...item,
          created_at: dayjs(item.created_at).format('DD/MM/YYYY'),
        }))
      );
    }
  };

  return (
    <ClientScreen
      data={data}
      company={company}
      user={user}
      // onRemove={item => swalRemove({ withError: false, functionConfirmRemove: () => onRemove(item) })}
    />
  );
};

export default ClientsContainer;
